"use client";
import { pushEvent } from "@/lib/analytics/gtm";
import { analyticsEvents } from "@/lib/analytics/events";

interface GetStickerButtonProps {
  postId: number | string;
  packTitle: string;
}

const PLAY_STORE =
  "https://play.google.com/store/apps/details?id=com.hqinfosystem.sticko.wastickerapps.stickers&referrer=utm_source%3Dweb%26utm_medium%3Dweb%26utm_content%3Dimageclick%26utm_campaign%3Dhomepage";
const APP_STORE = "https://apps.apple.com/in/app/sticko-animated-sticker-maker/id1592890261";

export function GetStickerButton({ postId, packTitle }: GetStickerButtonProps) {
  function handleClick() {
    const ua = window.navigator.userAgent.toLowerCase();
    const isIphone = /iphone|ipad|ipod/.test(ua);
    const isAndroid = /android/.test(ua);
    const platform = isIphone ? "ios" : isAndroid ? "android" : "desktop";
    const via = platform === "desktop" ? "store" : "deeplink";
    pushEvent(analyticsEvents.download_click, {
      post_id: String(postId),
      title: packTitle,
      platform,
      via,
    });
    const deepLink = `stickoapp://${window.location.hostname}/s/${postId}`;

    if (isIphone) {
      pushEvent(analyticsEvents.app_deeplink_redirect, {
        post_id: String(postId),
        platform,
      });
      window.location.href = deepLink;
      window.setTimeout(() => {
        window.location.href = APP_STORE;
      }, 500);
      return;
    }
    if (isAndroid) {
      pushEvent(analyticsEvents.app_deeplink_redirect, {
        post_id: String(postId),
        platform,
      });
      window.location.replace(deepLink);
      window.setTimeout(() => {
        window.location.href = PLAY_STORE;
      }, 500);
      return;
    }
    // Desktop / unknown: send to Play Store.
    window.open(PLAY_STORE, "_blank", "noopener,noreferrer");
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="rounded-pill bg-brand-500 hover:bg-brand-600 active:bg-brand-700 w-full px-6 py-3 text-[15px] font-semibold text-white transition"
    >
      Get Sticker
    </button>
  );
}
